import { FieldSize } from 'shared/types/fieldSize';

export const RICH_TEXT_MAX_LENGTH = FieldSize.RICH_TEXT;

export const HTML_TAG_REGEX = /<[^>]+>/;

export const ALLOWED_HTML_TAGS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  's', // strikethrough
  'strike', // strikethrough alternative
  'code', // inline code/tag
  'a', // links
  'ol',
  'ul',
  'li',
  'del', // strikethrough written by other editors
  'span', // text colour only: `<span style="color:#RRGGBB">` (PT-7250)
] as const;

/**
 * Single-line rich text (an `OPTION_SELECTION` option label): inline
 * formatting only, as the backend accepts it (PT-7251).
 */
export const ALLOWED_INLINE_HTML_TAGS = ['b', 'i', 'u', 's', 'del', 'strong', 'em', 'span'] as const;

/** Tags around a single-line value that are read as a space. */
export const LINE_BREAK_TAGS = ['p', 'div', 'br'] as const;

export const ALLOWED_HTML_ATTRIBUTES = ['style', 'href', 'target', 'rel'] as const;
